import { DesignChannelType, LegacyOption } from '../../types';

const channelLabels: Record<DesignChannelType, string> = {
  [DesignChannelType.email]: 'Email',
  [DesignChannelType.facebook]: 'FBM',
  [DesignChannelType.instagram]: 'Instagram',
  [DesignChannelType.mobile]: 'Mobile',
  [DesignChannelType.other]: 'Other',
  [DesignChannelType.socialChat]: 'Social Chat',
  [DesignChannelType.sms]: 'SMS',
  [DesignChannelType.twitter]: 'Twitter',
  [DesignChannelType.voice]: 'Voice',
  [DesignChannelType.webChat]: 'Web',
  [DesignChannelType.whatsApp]: 'WhatsApp'
};

export const channelTypeOptions: LegacyOption<DesignChannelType>[] = Object.entries(
  channelLabels
).map(([type, label]) => {
  return {
    name: label,
    value: type as DesignChannelType
  };
});
